<template>
  <div id="modules-table">
    <div id="modals">
      <new-module-modal v-if="modals.new_module" v-model:modal_show="modals.new_module" :module_list="module_list"
        :plot_list="plot_list" :key="modals.new_module" v-model:on_data_submit="table_rerender"></new-module-modal>

      <param-modal v-if="modals.param" v-model:modal_show="modals.param" :params="selected_module.params"
        :module_id="selected_module.id" :module_name="selected_module.name" :key="modals.param"
        v-model:on_data_submit="table_rerender"></param-modal>

      <module-modal v-if="modals.module_mod" v-model:modal_show="modals.module_mod" :module_data="selected_module"
        :plot_list="plot_list" :module_list="module_list" :key="modals.module_mod"
        v-model:on_data_submit="table_rerender"></module-modal>

      <module-status v-if="modals.module_status" v-model:modal_show="modals.module_status"
        :module_data="selected_module"></module-status>

    </div>
    <div class="card">
      <div class="card-header border-0">
        <div class="row align-items-center">
          <div class="col-auto">
            <h3 class="mb-0">{{ $t($route.name + '.moduleManagerTitle') }}</h3>
          </div>
          <div class="col">
          </div>
          <div class="col-auto">
            <base-button type="success" icon="ni ni-fat-add" v-on:click="onNewModuleButton()">{{ $t($route.name +
              '.newModuleButton') }}
            </base-button>
          </div>
        </div>
      </div>
      <div class="table-responsive">
        <base-table thead-classes="thead-light" :data="module_list">
          <template v-slot:columns>
            <th>{{ $t($route.name + '.moduleNameHeader') }}</th>
            <th>{{ $t($route.name + '.moduleModifyModule') }}</th>
            <th>{{ $t($route.name + '.modulePlotHeader') }}</th>
            <th>{{ $t($route.name + '.moduleTypeHeader') }}</th>
            <th>{{ $t($route.name + '.moduleInstallationDateHeader') }}</th>
            <th>{{ $t($route.name + '.moduleLocationHeader') }}</th>
          </template>

          <template v-slot:default="row">
            <th scope="row">
              {{ row.item.name }}
            </th>
            <td>
              <a type="button" style="padding: 2px;"
                v-on:click="this.selected_module = row.item; this.modals.module_mod = true;">
                <i class="bi bi-pencil-fill text-red fa-2x"></i>

              </a>


              <a type="button" style="padding: 2px;"
                v-on:click=" this.selected_module = row.item; this.modals.param = true;">

                <i class="ni ni-settings-gear-65 text-blue fa-2x"></i>
              </a>
              <a type="button" style="padding: 2px;"
                v-on:click=" this.selected_module = row.item; this.modals.module_status = true;">
                <i class="bi bi-eye-fill fa-2x"></i>
              </a>

            </td>
            <td>
              <span v-if="row.item.plot_name != 'UnallocatedModulesPlot'">{{ row.item.plot_name }}</span>
              <span v-else>{{ $t($route.name + '.moduleNotPlotAllocated') }}</span>
            </td>
            <td>
              {{ row.item.hw_specs.type + row.item.hw_specs.version + "." + row.item.sw_specs.version }}
            </td>
            <td>
              {{ convertFromISODatetime(row.item.installation_date) }}
            </td>
            <td>
              {{ row.item.latitude }}, {{ row.item.longitude }}
            </td>
          </template>
        </base-table>
      </div>
    </div>


  </div>
</template>
<script lang="js">
//import ModuleService from '../../services/module.service';
import LandlordService from '@/services/landlord.service'
import ParamModal from './ParamModal'
import ModuleModal from './ModuleModal'
import NewModuleModal from './NewModuleModal'
import ModuleStatus from './ModuleStatus'

export default {
  name: "modules-table",
  components: {
    ParamModal,
    ModuleModal,
    NewModuleModal,
    ModuleStatus,
  },
  props: {
    rerender_key: {
      type: Boolean,
      default: false,
    }
  },
  created() {
    const user = JSON.parse(localStorage.getItem("user")).user;



    LandlordService.getLandlordAllDataById(user.id).then(
      landlord => {
        const moduleId = localStorage.getItem("moduleId")
        this.selected_module = ''
        this.landlord = landlord;
        this.landlord.terrains.forEach(terrain => {
          terrain.plots.forEach(plot => {
            this.plot_list.push(plot);
            plot.modules.forEach(module => {
              module.plot_name = plot.name;
              if (module.id == moduleId) {
                this.selected_module = module
              }
              this.module_list.push(module);
            })
          })
        })
        if (moduleId == 'null') {
          this.selected_module = ''
        } else if (moduleId == 'new_module') {
          this.modals.new_module = true;
        } else {
          this.modals.module_mod = true;
        }

      }
    )
  },
  data() {
    return {
      modals: {
        new_module: false,
        param: false,
        module_mod: false,
        btn: false,
        module_status: false,
      },
      landlord: null,
      module_list: [],
      plot_list: [],
      selected_module: "",
      table_rerender: false,
    };
  },
  methods: {
    convertFromISODatetime(datetime_str) {
      if (datetime_str == null) {
        return ""
      }
      const date_split = datetime_str.split('.')[0].split('T');
      if (date_split[1]) {
        return date_split[0] + ' ' + date_split[1]
      }
      return date_split[0]

    },
    onNewModuleButton() {
      localStorage.setItem('moduleId', null)
      localStorage.setItem('plotId', null)
      this.modals.new_module = true
    },
  },
  watch: {
    table_rerender: function () {
      this.$emit('update:rerender_key', !this.rerender_key);
    }
  }
};
</script>
<style></style>